import { render, staticRenderFns } from "./DevelopmentsByInmo.vue?vue&type=template&id=ef9c7c64"
import script from "./DevelopmentsByInmo.vue?vue&type=script&lang=js"
export * from "./DevelopmentsByInmo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports